import React, { useEffect } from 'react'
import { Table, Image, message } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { useLedgerModel } from '../ledgerModel'
import { ILedgerDetail } from '../ledgerService'
import useNavModel from '@/model/navModel'
import { getBaseImgLookUrl } from '@/utils/constants'
import { threeInspectionStatus } from '@/types/AppEnums'
import { FormOutlined } from '@ant-design/icons'
import { Button } from 'antd/lib/radio'

export function DataTable() {
    const { dataSource, selectedRowKeys, pgCfg, loading, loadData, setSelectedRowKeys, setEditCarVisible } = useLedgerModel()

    useEffect(() => {
        loadData().then(() => {})
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const { addNav, findNav, switchNavState } = useNavModel(() => [])
    const columns: ColumnsType<ILedgerDetail> = [
        {
            title: '序号',
            width: 55,
            align: 'center',
            render: (_t, _r, i) => i + 1,
        },
        {
            title: '操作',
            width: 80,
            align: 'center',
            render: (_t: any, record: ILedgerDetail) => (
                <Button
                    onClick={() => {
                        if (canEdit(record.departureTime)) {
                            setEditCarVisible({ visible: true, value: { ...record } })
                        }
                    }}
                >
                    <FormOutlined style={{ cursor: 'pointer' }} />
                </Button>
            ),
        },
        {
            title: '车头',
            width: 160,
            align: 'center',
            dataIndex: 'vehicleNumber',
            render: (text, records) => (
                <span style={{ color: '#4165E3', cursor: 'pointer' }} onClick={() => detialLook(records)}>
                    {text}
                </span>
            ),
        },
        {
            title: '头像',
            width: 140,
            align: 'center',
            render: (_text, records) => (records.md5 ? <Image src={getBaseImgLookUrl(records.md5)} style={{ maxWidth: '50px', maxHeight: '70px' }} /> : null),
        },
        {
            title: '司机',
            width: 160,
            align: 'center',
            dataIndex: 'driverName',
            render: (text) => <span>{text}</span>,
        },
        {
            title: '押运员',
            width: 160,
            align: 'center',
            dataIndex: 'escortName',
            render: (text) => <span>{text}</span>,
        },
        {
            title: '挂车',
            width: 160,
            align: 'center',
            dataIndex: 'trailerNumber',
            render: (text) => <span>{text}</span>,
        },
        {
            title: '开始日期',
            width: 160,
            align: 'center',
            dataIndex: 'departureTime',
            render: (text) => <span>{text}</span>,
        },
        {
            title: '结束日期',
            width: 160,
            align: 'center',
            dataIndex: 'departureEndTime',
            render: (text) => <span>{text}</span>,
        },
        {
            title: '路线',
            width: 160,
            align: 'center',
            dataIndex: 'lineName',
            render: (text) => <span>{text}</span>,
        },
        {
            title: '测试状态',
            width: 160,
            align: 'center',
            dataIndex: 'customerVehicleBrand',
            render: (_text, records) => (
                <>
                    <span style={{ display: 'block' }}>
                        前({records.frontNum < records.frontTotalNum || records.frontNum === 0 ? '未完成' : '已完成'})：{records.frontNum}/
                        {records.frontTotalNum}
                    </span>
                    <span style={{ display: 'block' }}>
                        中({records.inNum < records.inTotalNum || records.inNum === 0 ? '未完成' : '已完成'})：{records.inNum}/{records.inTotalNum}
                    </span>
                    <span style={{ display: 'block' }}>
                        后({records.afterNum < records.afterTotalNum || records.afterNum === 0 ? '未完成' : '已完成'})：{records.afterNum}/
                        {records.afterTotalNum}
                    </span>
                </>
            ),
        },
        {
            title: '发车状态',
            width: 160,
            align: 'center',
            dataIndex: 'threeInspectionStatus',
            render: (text) => <span>{threeInspectionStatus[text]}</span>,
        },
        {
            title: '前签名',
            width: 140,
            align: 'center',
            render: (_text, records) => (
                <div>
                    {records.circulationLogList?.length > 0 && records.circulationLogList[0].signMd5 ? (
                        <Image
                            src={getBaseImgLookUrl(records.circulationLogList[0].signMd5)}
                            style={{ maxWidth: '50px', maxHeight: '70px', display: 'block' }}
                        />
                    ) : null}
                    <div>{records.recordList?.length > 0 ? records.recordList.find((item: any) => item.phaseType === '前')?.address : ''}</div>
                </div>
            ),
        },
        {
            title: '中签名',
            width: 140,
            align: 'center',
            render: (_text, records) => (
                <div>
                    {records.circulationLogList?.length > 1 && records.circulationLogList[1].signMd5 ? (
                        <Image
                            src={getBaseImgLookUrl(records.circulationLogList[1].signMd5)}
                            style={{ maxWidth: '50px', maxHeight: '70px', display: 'block' }}
                        />
                    ) : null}
                    <div>{records.recordList?.length > 0 ? records.recordList.find((item: any) => item.phaseType === '中')?.address : ''}</div>
                </div>
            ),
        },
        {
            title: '后签名',
            width: 140,
            align: 'center',
            render: (_text, records) => (
                <div>
                    {records.circulationLogList?.length > 2 && records.circulationLogList[2].signMd5 ? (
                        <Image
                            src={getBaseImgLookUrl(records.circulationLogList[2].signMd5)}
                            style={{ maxWidth: '50px', maxHeight: '70px', display: 'block' }}
                        />
                    ) : null}
                    <div>{records.recordList?.length > 0 ? records.recordList.find((item: any) => item.phaseType === '后')?.address : ''}</div>
                </div>
            ),
        },
    ]
    const detialLook = (record: any) => {
        let supplierEditKey = '3-2-1'
        let isFindNav = findNav(supplierEditKey)
        window.localStorage.setItem(
            'ledgerDetails',
            JSON.stringify({
                inTotalNum: record.inTotalNum,
                frontTotalNum: record.frontTotalNum,
                afterTotalNum: record.afterTotalNum,
            }),
        )
        if (!isFindNav) {
            addNav(supplierEditKey, {
                id: record?.id,
                vehicleNumber: record?.vehicleNumber,
                createTime: record?.createTime,
                mode: 'look',
            })
        } else {
            switchNavState(supplierEditKey, {
                id: record?.id,
                vehicleNumber: record?.vehicleNumber,
                createTime: record?.createTime,
                mode: 'look',
            })
        }
    }

    const canEdit = (departureTime: string | undefined) => {
        if (!departureTime) return false
        const depDate = new Date(departureTime)
        depDate.setHours(0, 0, 0, 0)
        const now = new Date()
        now.setHours(0, 0, 0, 0)
        const diffDays = Math.floor((now.getTime() - depDate.getTime()) / (1000 * 60 * 60 * 24))
        if (diffDays === 1 || diffDays === 2) {
            return true
        }
        message.warning('当前记录不可编辑，仅可在日期后一天或两天内编辑')
        return false
    }

    const rowSelection = {
        onChange(selectedRowKeys: any) {
            setSelectedRowKeys(selectedRowKeys)
        },
        selectedRowKeys,
    }
    const onRow = (record: any) => {
        return {
            onClick: () => {
                if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.id) {
                    setSelectedRowKeys([])
                } else {
                    setSelectedRowKeys([record.id as any])
                }
            },
        }
    }
    return (
        <Table
            rowKey={(record) => record?.id as string}
            loading={loading}
            rowSelection={{
                type: 'radio',
                ...rowSelection,
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ['bottomRight'],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then(() => {})
                },
                showSizeChanger: true,
            }}
            bordered
            onRow={onRow}
            scroll={{ x: 'max-content', y: 'calc(100vh - 380px)' }}
        />
    )
}
